"use strict";
exports.__esModule = true;
exports.SvgConversationsHover = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgConversationsHover = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 14 14" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { d: "M14 14H0V0h14z" }),
        react_1["default"].createElement("path", { fill: "#727272", fillRule: "nonzero", d: "M11.29 2H2.781C1.452 2 1.012 2.355 1 3.62v5.707l.002.167c.032 1.129.405 1.51 1.525 1.514l1.389-.001v2.243l.007.103c.079.603.836.877 1.28.42L7.9 11.007h3.252c1.402 0 1.848-.37 1.848-1.744V3.759c0-1.314-.433-1.75-1.71-1.759z" })))); };
//# sourceMappingURL=ConversationsHover.js.map